<script setup lang="ts">
const store = useStore()
const user = computed(() => store.user)
const props = defineProps({
  version: String,
})
store.initApp(props.version!)

function toggleSidebar() {
  store.toggleSidebar()
}
</script>
<template>
  <div class="pb-2">
    <p v-if="user" @click="toggleSidebar">
      Kirjautuneena käyttäjänä
      <span class="underline cursor-pointer">{{ user.user_metadata.display_name }}</span>
    </p>
    <p v-else @click="toggleSidebar"><span class="underline cursor-pointer">Kirjaudu</span></p>
  </div>
</template>
